import './ViewRules.css';
import { Box, CircularProgress } from '@mui/material';
import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BhpButton } from '../../components/BhpButton';
import { VillageRuleDto } from '../../dtos/VillageRuleDto';
import ParseHtml from 'html-react-parser';
import { useVillageRules } from '../../hooks/useVillageRules';
import VillageConsoleContext from '../../store/VillageConsoleContext';
import React from 'react';


export const ViewRules: React.FC = () => {

    const [ villageRuleId, setVillageRuleId ] = useState<number>( );
    const [ villageRule, setVillageRule ] = useState<VillageRuleDto>( );


    let { id } = useParams( );
    const { domain } = useContext( VillageConsoleContext );
    const navigate = useNavigate( );
    const { getVillageRule } = useVillageRules( );


    const handleDownloadPdfClick = ( villageRule : VillageRuleDto ) => {
        
        const linkSource = `data:application/pdf;base64,${villageRule.rulePdf}`;
        const downloadLink = document.createElement( 'a' );
        const fileName = `VillageRules-BMA-${villageRule.version}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click( );

    }
    
    useEffect( () => {

        if( !id || isNaN( +id ))
        {
            
            navigate( '/search-rules' );

        } else {
            
            setVillageRuleId( +id );

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect( () => {

        const fetchVillageRule = async ( ) => {

            if( !villageRuleId ) {

                return;
    
            }

            const villageRule = await getVillageRule( domain, villageRuleId );
            
            if( villageRule ){

                setVillageRule( villageRule );

            }

        }; 

        fetchVillageRule( );


    }, [villageRuleId]);

    return (
            
        villageRule ? 
        
        <div style={{ marginLeft: '10px', marginRight: '10px' }}>

            { ParseHtml( villageRule.ruleHtml ) }

            <BhpButton 
                onClick={ ( ) => { handleDownloadPdfClick(villageRule); } }
                sx={{ marginBottom: '10px' }}
            >
                Download as PDF
            </BhpButton>

        </div>

        :

        <Box 
            display="flex" 
            alignItems="center"
            justifyContent="center"
            height={'100vh'}
        >
            <CircularProgress size="80px" sx={{color: '#e65400'}}/>
        </Box>
    
    );

};